import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-cream py-12 sm:py-16" data-id="element-24" data-mp="18709zd2d32g9">
      <div className="mx-auto max-w-5xl px-5" data-id="element-25" data-mp="13cmktsealrk1">
        <div className="text-center" data-id="element-26" data-mp="yeuh814ach00">
          <SectionTag data-id="element-27" data-mp="ydrum5dzx0pw">Libro + 5 bonos = un sistema</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[24ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-28" data-mp="tfq7n9dg8h95">
            El libro te dice qué hacer. Los bonos te ayudan a{' '}
            <span className="text-gold" data-id="element-29" data-mp="kfuuiz0c2c6h">salir a ofrecerlo</span>.
          </h2>
          <p className="mx-auto mt-3 max-w-[44ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:max-w-2xl" data-id="element-30" data-mp="fgqlq9hbmggo">
            No son PDFs sueltos de regalo: cada bono destraba el paso que viene después de cocinar.
          </p>
        </div>

        <ul className="mt-7 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-31" data-mp="29urhglhkqncj">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.04
        }} className="flex h-full items-start gap-3 overflow-hidden rounded-2xl border border-stone bg-white p-3 shadow-[0_14px_34px_-30px_rgba(56,37,34,0.6)]" data-id="element-32" data-mp="qxineivqlfc9" data-mpi={i}>
              <div className="relative h-[76px] w-[76px] shrink-0 overflow-hidden rounded-xl bg-sand sm:h-[84px] sm:w-[84px]" data-id="element-33" data-mp="1ek7adizlrxzq">
                {bono.cover && <img src={bono.cover} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-34" data-mp="15rvpsdr674ro" />}
              </div>
              <div className="min-w-0 py-0.5" data-id="element-35" data-mp="284oomarkuvj9">
                <p className="font-display text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-36" data-mp="284gakfjpxk6h">
                  Paso {bono.num} · {bono.role}
                </p>
                <h3 className="mt-1 font-display text-[0.92rem] font-bold leading-tight tracking-tight text-charcoal" data-id="element-37" data-mp="1y5r3lhtd1k50">
                  {bono.name}
                </h3>
                <p className="mt-1 font-sans text-[0.79rem] leading-snug text-taupe" data-id="element-38" data-mp="1p5ua92w0zx3m">{bono.desc}</p>
              </div>
            </motion.li>)}

          <li className="flex h-full flex-col justify-center rounded-2xl bg-sand p-5 ring-1 ring-stone" data-id="element-39" data-mp="1ke2qpcbaermz">
            <p className="font-display text-[1.05rem] font-extrabold leading-tight tracking-tight text-charcoal" data-id="element-40" data-mp="1fgkjbqcx4kh3">
              De cocinar postres a tener una propuesta lista.
            </p>
            <p className="mt-2 font-sans text-[0.82rem] leading-relaxed text-taupe" data-id="element-41" data-mp="15hbokva8b1to">
              Los 5 bonos vienen incluidos en la compra.
            </p>
          </li>
        </ul>
      </div>
    </section>;
}